/*
 * File: PriceBookField.tsx
 * Project: a-a
 * File Created: Monday, 23rd June 2025 5:31:42 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 10th July 2025 6:17:56 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Skeleton,
  Typography,
  useTheme,
} from '@mui/material';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import zeplinColor from '../../../../../theme/Color';
import { useEffect, useState } from 'react';
import { ClientService } from '../../../../../service/client.service';
import { Utilities } from '../../../../../utilities/utilities';
const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};
const PriceBookField = ({
  handleInputChange,
  value,
  setPricebookName,
  modal,
}: {
  handleInputChange: (field: string, value: any) => void;
  setPricebookName: React.Dispatch<React.SetStateAction<string>>;
  modal: boolean;
  value: any;
}) => {
  const [selectedItems, setSelectedItems] = useState<{
    priceBook: string[];
  }>({
    priceBook: value?.pricebook2Id ? [value?.pricebook2Id] : ['none'],
  });
  const theme = useTheme();
  const [pricebook, setPricebook] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;
    if (Array.isArray(item)) {
      setSelectedItems((prev) => ({ ...prev, [key]: [...item] }));
    } else if (item?.target?.value) {
      const {
        target: { value },
      } = item;

      setSelectedItems((prev) => ({
        ...prev,
        [key]: typeof value === 'string' ? value.split(',') : value,
      }));
    } else {
      setSelectedItems((prev) => ({
        ...prev,
        [key]: [item],
      }));
    }
  };
  const getPriceBook = async () => {
    try {
      setLoading(true);
      const res = await ClientService.getPricebooks();

      setPricebook(res);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getPriceBook();
  }, []);

  useEffect(() => {
    setPricebookName(
      Utilities.getMatchingRecordTypeKey(selectedItems.priceBook[0], pricebook) || '',
    );
  }, [selectedItems.priceBook[0], pricebook]);
  return (
    <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
      <Typography variant='heading4'>Choose Price Book</Typography>
      <Typography variant='body2' color={zeplinColor.Neutral9}>
        Select a Price Book to associate with this deal. You can add products only from the Price
        Book you associate with this deal. Changing the Price Book deletes all products from the
        deal.
      </Typography>
      <FormControl sx={{ width: '100%' }}>
        <InputLabel
          id='demo-multiple-name-label'
          sx={{
            '&.Mui-focused': { color: zeplinColor.Neutral9 },
          }}
        >
          Price book<span style={{ color: zeplinColor.Error }}></span>
        </InputLabel>
        <Select
          labelId='demo-multiple-name-label'
          id='demo-multiple-name'
          // multiple
          required={true}
          value={selectedItems.priceBook}
          onChange={(e) => {
            handleSelection(e, 'priceBook');

            handleInputChange('pricebook2Id', e.target.value);
          }}
          input={
            <OutlinedInput
              sx={{
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '1px',
                  color: zeplinColor.Neutral9,
                  borderColor: zeplinColor.Neutral9,
                },
              }}
              label='Price Book'
            />
          }
          renderValue={
            (selected) =>
              // (selected as string[]).map((val) => (
              {
                return loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      fontSize: theme.typography.body2,
                      width: '100%',
                      // Optionally adjust other styles here
                    }}
                  />
                ) : selected?.length ? (
                  selected[0] === 'none' ? (
                    'None'
                  ) : Object.keys(pricebook)?.length &&
                    Utilities.getMatchingRecordTypeKey(selectedItems.priceBook[0], pricebook) ? (
                    Utilities.getMatchingRecordTypeKey(selectedItems.priceBook[0], pricebook)
                  ) : (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        width: '100%',
                        // Optionally adjust other styles here
                      }}
                    />
                  )
                ) : (
                  ''
                );
              }
            // ))
          }
          MenuProps={MenuProps}
          IconComponent={KeyboardArrowDown}
        >
          <MenuItem key={'none'} value={'none'}>
            <Radio
              checked={
                selectedItems?.priceBook?.length
                  ? selectedItems?.priceBook?.indexOf('none') > -1
                  : false
              } // Check if this radio should be selected
              sx={{
                color: zeplinColor.BasicBlack,
                '&.Mui-checked': {
                  color: zeplinColor.BasicBlack,
                },
              }}
            />
            ----None----
          </MenuItem>
          {Object.keys(pricebook)?.length > 0 &&
            Object.keys(pricebook)?.map((name: any) => (
              <MenuItem key={pricebook[name]} value={pricebook[name]}>
                <Radio
                  checked={
                    selectedItems?.priceBook?.length
                      ? selectedItems?.priceBook?.indexOf(pricebook[name]) > -1
                      : false
                  } // Check if this radio should be selected
                  sx={{
                    color: zeplinColor.BasicBlack,
                    '&.Mui-checked': {
                      color: zeplinColor.BasicBlack,
                    },
                  }}
                />
                {name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PriceBookField;
